<template>
  <div class="image-picker" @click="openFileManager = true">
    <i v-if="local_file_url" @click="removeFile($event)" class="fas text-danger fa-trash-can img-del-btn"></i>
    <a @click.stop v-if="local_file_url" target="_blank" class="download-img" :href="local_file_url"><i  class="fas text-info fa-download"></i></a>
    <img class="img-preview" :src="(local_file_url?local_file_url:default_img_url)" alt="">
    <input type="hidden" hidden readonly :name="name" :value="local_file_id">
  </div>
  <FileManager v-if="openFileManager" @closeFileManager="openFileManager =false" @changeFile="changeFile"></FileManager>
</template>
<script>
import Loading from "@/components/Loading";
import FileManager from "@/components/FileManager";
export default {
name: "ImagePicker",
  components: {FileManager, Loading},
  props:['name','imag_src','file_url','file_id','modelValue'],
  emits: ['update:modelValue'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  mounted()
  {
      this.value = this.file_id;
  },
  data(){
  return{
    default_img_url : require('@/assets/image-icon.svg'),
    openFileManager:false,
    file_page_active : true,
    dragging : false,
    results  : null,
    apiUrl : process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH,
    loading : false,
    local_file_id : this.file_id,
    local_file_url : this.file_url,
  }
  },
  methods:{
    changeFile(file)
    {
      if (file)
      {
        this.value = file._id;
        this.local_file_id = file._id;
        this.local_file_url = file.img_url;
      }
    },
    removeFile(e)
    {
      e.preventDefault();
      e.stopPropagation();
      this.local_file_id = null;
      this.local_file_url = null;
      this.value = null;
    }
  }
  ,watch:{
    openFileManager:{
    handler(vale)
    {
      if (vale)
        document.body.classList.add('modal-open');
      else
        document.body.classList.remove('modal-open');
    },deep:true
  }
  }
}
</script>

<style scoped>
.image-picker {
  width: 100px;
  height: 100px;
  padding: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: -1px 1px 6px 1px #00000057;
  transition: all 400ms;
  border-radius: 8px;
}
.image-picker .img-preview
{
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 400ms;
}
.image-picker:hover>.img-preview
{
  transform: scale(1.1);
}
.img-del-btn
{
  right: 4px;
  top: 8px;
  position: absolute;
  font-size: 18px;
  z-index: 3;
  background: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 26px;
}
.download-img {
  left: 4px;
  top: 8px;
  position: absolute;
  font-size: 18px;
  z-index: 3;
  background: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 26px;
}
.download-img *
{
  pointer-events: inherit;
}
</style>